import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let AmFeStep = class AmFeStep extends Vue {};
AmFeStep.componentName = 'AmFeStep';
__decorate([Prop()], AmFeStep.prototype, "space", void 0);
__decorate([Prop({
  default: 'horizontal'
})], AmFeStep.prototype, "direction", void 0);
__decorate([Prop({
  default: 0
})], AmFeStep.prototype, "active", void 0);
__decorate([Prop({
  default: 'process'
})], AmFeStep.prototype, "processStatus", void 0);
__decorate([Prop({
  default: 'finish'
})], AmFeStep.prototype, "finishStatus", void 0);
__decorate([Prop({
  default: false
})], AmFeStep.prototype, "alignCenter", void 0);
__decorate([Prop({
  default: false
})], AmFeStep.prototype, "simple", void 0);
__decorate([Prop({
  default: () => []
})], AmFeStep.prototype, "options", void 0);
AmFeStep = __decorate([Component({
  name: 'AmFeStep'
})], AmFeStep);
export default AmFeStep;